export const clearLocalStorage = (permitKeys: string[] = []) => {
  const storageKeys = Object.keys(localStorage);

  storageKeys.forEach(key => {
    if (!permitKeys.includes(key)) {
      localStorage.removeItem(key);
    }
  });
};
